import styled, { css } from 'styled-components';
import { up } from 'styled-breakpoints';

interface StreaksButtonContainerProps {
  isBgTransparent?: boolean;
}

export const StreaksButtonContainer = styled.div<StreaksButtonContainerProps>`
  margin-right: -5rem;

  ${up('tablet-portrait')} {
    margin-right: -7rem;
  }

  animation: streak-onload-slide-in 3s ease 3s;
  animation-fill-mode: forwards;

  @keyframes streak-onload-slide-in {
    0% {
      opacity: 0;
    }
    33%,
    100% {
      margin-right: 0;
      opacity: 1;
    }
  }

  & > button {
    min-width: auto;
    padding: ${({ theme: { spacing } }): string => spacing.sm2} 0;
    margin-left: ${({ theme: { spacing } }): string => spacing.sm3};
    margin-right: ${({ theme: { spacing } }): string => spacing.sm2};

    ${up('tablet-portrait')} {
      margin-left: 1.75rem;
      margin-right: ${({ theme: { spacing } }): string => spacing.sm4};
    }

    & > svg {
      fill: ${({ theme: { colors } }): string => colors.white} !important;
      border: 1px solid ${({ theme: { colors } }): string => colors.white};
      border-radius: 1rem;
      transform: scale(0.7);
      padding: 0.063rem;

      background-image: ${({ isBgTransparent }): string =>
        isBgTransparent
          ? 'linear-gradient(rgba(0, 0, 0, 0.35) 30%, #6531e9 51%, #00b8ff 100%)'
          : 'linear-gradient(rgb(0, 0, 0) 30%, #6531e9 51%, #00b8ff 100%)'};
      background-size: auto 300%;
      background-position: 0% 0%;

      animation: streak-icon-onload 2.5s ease-in-out 3s,
        streak-icon-glow-effect 45s ease-in 45s infinite;

      ${up('tablet-portrait')} {
        transform: scale(1);
        padding: 0.188rem;
      }

      @keyframes streak-icon-onload {
        0%,
        100% {
          border: 1px solid ${({ theme: { colors } }): string => colors.white};
          background-position: 0% 0%;
        }
        50% {
          border: hidden;
          background-position: 0% 90%;
        }
      }

      @keyframes streak-icon-glow-effect {
        0%,
        8.88% {
          border: 1px solid ${({ theme: { colors } }): string => colors.white};
          background-position: 0% 0%;
        }
        1.11%,
        5.55% {
          border: hidden;
          background-position: 0% 90%;
        }
      }
    }
  }
`;

export const CounterContainer = styled.div`
  min-width: 3ch;
  animation: streak-count-onload 3s ease-out 3s;

  ${up('tablet-portrait')} {
    line-height: 1.145;
  }

  @keyframes streak-count-onload {
    0%,
    33% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const ToolTipCSS = css`
  & > div {
    align-items: flex-start;

    & > div {
      width: auto;
      position: absolute;
      top: 3.75rem;
      right: ${({ theme: { spacing } }): string => spacing.md1};

      ${up('tablet-portrait')} {
        top: 4.125rem;
        right: ${({ theme: { spacing } }): string => spacing.md4};
      }
    }

    div[data-id='modal-backdrop'] {
      top: ${({ theme: { spacing } }): string => spacing.sp0};
      right: ${({ theme: { spacing } }): string => spacing.sp0};
    }
  }
`;
